import React, { Component } from 'react';
import { CircleCheckBig } from 'lucide-react';
import { APP_CONST } from '../../../../../../constants';
import { GeckoFields, GeckoBtn, Spinner, Label, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../../../components';

export class Manage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            Software: false,
            SMS: false,
            preferred: props.default,
            unsavedChanges: false,
            ...props.preferences,
        }

        this.submit = this.submit.bind(this);
    }

    handleChange(name, evt) {
        this.setState({[name]: evt, unsavedChanges: true});
    }

    handlePreferredChange(value) {
        this.setState({preferred: value, unsavedChanges: true});
    }

    fields()
    {
        return [{
            key: '2fa_methods_label',
            render: () => (
                <div className="flex flex-col">
                    <label className="text-sm font-semibold text-foreground">
                        Select which methods of 2FA to enable
                    </label>
                </div>
            ),
        }, {
            label: 'Authenticator app',
            key: 'Software',
            description: 'Use an authenticator app like Google Authenticator or Authy',
            disabledWhen: () => false,
            type: APP_CONST.FIELD_TYPE_TOGGLE,
        }, {
            label: 'SMS',
            key: 'SMS',
            description: 'Receive verification codes via text message',
            disabledWhen: () => false,
            type: APP_CONST.FIELD_TYPE_TOGGLE,
        }];
    }

    renderSelect() {
        let disabled = false;
        let disabledSoftware = false;
        let disabledSMS = false;

        if (!this.state.Software && !this.state.SMS) {
            disabled = true;
        }

        if (!this.state.Software) {
            disabledSoftware = true;
        }

        if (!this.state.SMS) {
            disabledSMS = true;
        }

        const selectValue = this.state.preferred || 'none';

        return (
            <div className="flex flex-col gap-1">
                <Label htmlFor="preferred">Preferred method</Label>
                <Select 
                    value={selectValue} 
                    onValueChange={this.handlePreferredChange.bind(this)}
                    disabled={disabled}
                >
                    <SelectTrigger id="preferred" className="w-full">
                        <SelectValue placeholder="Select a method" />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="none">No preference</SelectItem>
                        <SelectItem value="SOFTWARE" disabled={disabledSoftware}>
                            Authenticator app
                        </SelectItem>
                        <SelectItem value="SMS" disabled={disabledSMS}>
                            SMS
                        </SelectItem>
                    </SelectContent>
                </Select>
            </div>
        )
    }

    submit() {
        let preferred = this.state.preferred;
        
        if (!this.state.Software && !this.state.SMS) {
            preferred = null;
        }

        if (preferred === 'none') {
            preferred = null;
        }

        return this.props.updatePreferences(this.state.SMS, this.state.Software, preferred)
            .then(() => {
                this.setState({ unsavedChanges: false });
            });
    }

    render() {
        return (
            <div className="flex flex-col gap-4">
                <GeckoFields 
                    fields={this.fields()}
                    values={this.state}
                    handler={this.handleChange.bind(this)}
                    submitHandler={() => {}} 
                />

                {this.renderSelect()}

                <div className="flex">
                    <GeckoBtn 
                        name={'Update'}
                        icon={CircleCheckBig}
                        type={APP_CONST.BTN_TYPE_PRIMARY}
                        className={'self-start'}
                        hideWhen={() => !this.state.unsavedChanges}
                        handler={this.submit} 
                    />
                </div>
            </div>
        )
    }
}

Manage.defaultProps = {
    updatePreferences: () => null,
    default: null,
    preferences: {},
}

export default Manage;